import { ObjectPaths } from '@/types/utils';

import { z } from 'zod';

const PermissionSchema = z.object({
  global: z.boolean(),
  site: z.boolean(),
});

const CrudPermissionSchema = z.object({
  canRead: PermissionSchema,
  canEdit: PermissionSchema,
  canDelete: PermissionSchema,
});

export const RolePermissionsSchema = z.object({
  pii_access: PermissionSchema,
  eligibility_checklist: z.object({
    canPerformPrimaryCheck: PermissionSchema,
    canPerformSecondaryCheck: PermissionSchema,
    canPerformCoInvestigatorCheck: PermissionSchema,
    canApproveOverallEligibility: PermissionSchema,
  }),
  assessments: CrudPermissionSchema,
  consent_form: CrudPermissionSchema,
  subject: CrudPermissionSchema,
  study_profile: CrudPermissionSchema,
  patient: CrudPermissionSchema,
  site: CrudPermissionSchema,
  user: CrudPermissionSchema,
});

export type RolePermissions = z.infer<typeof RolePermissionsSchema>;
export type Permission = z.infer<typeof PermissionSchema>;
export type PermissionPath = ObjectPaths<RolePermissions, Permission>;
